import { useEffect, useState } from 'react'
import type { ContentBlock as ContentBlockType } from '../../../../shared/types'

interface UseSlideshowProps {
  contentBlock: ContentBlockType
  autoplayDelay?: number
}

const useSlideshow = ({
  contentBlock,
  autoplayDelay = 3000,
}: UseSlideshowProps) => {
  const content = contentBlock.content || []
  const [currentSlide, setCurrentSlide] = useState(0)
  const autoPlay = contentBlock?.autoPlay || true

  useEffect(() => {
    if (!autoPlay || content.length <= 1) return

    const interval = setInterval(() => {
      setCurrentSlide((prevIndex) => (prevIndex + 1) % content.length)
    }, autoplayDelay)

    return () => clearInterval(interval)
  }, [content.length, autoPlay, autoplayDelay])

  return {
    currentSlide,
    totalSlides: content.length,
    setCurrentSlide,
  }
}

export default useSlideshow
